import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToHashElement: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Remove o # do hash
      const id = location.hash.replace('#', '');
      
      // Pequeno delay para garantir que o DOM foi renderizado
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // Se não há hash, scroll para o topo
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
};

export default ScrollToHashElement;
